import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import { Modal } from 'jl-design-system/components/modal/Modal';
import { Message } from 'jl-design-system/components/message/Message';
import Icon from '../icon/Icon';
import {
  submitVoucher as submitVoucherAction,
  ADD_VOUCHER,
} from '../../actions/voucher/voucherActions';
import addVoucherConfig from '../../form/addVoucherConfig';
import renderPrice from '../../utils/string/renderPrice';

import styles from './add-voucher-modal.scss';
import base from '../../scss/base.scss';
import sessioncam from '../../utils/sessioncam';
import { analyticsTrigger } from '../../utils/analytics/trigger/analyticsTrigger';
import {
  analyticsPageNames as pageNames,
  DATA_STATE_CHANGE,
} from '../../constants/analyticsConstants';

const formConfig = addVoucherConfig();

export class AddVoucherModal extends Component {
  onFormSubmit = (formData) => {
    const { submitVoucher } = this.props;
    const { securityCode, serialNumber } = formData;

    const params = {
      securityCode,
      serialNumber,
    };

    return submitVoucher(params);
  };

  onModalClose() {
    sessioncam.closeVirtualPage();
    analyticsTrigger(DATA_STATE_CHANGE, pageNames.ACCOUNT);
    this.props.onClose();
  }

  static onSubmitFail() {
    sessioncam.createVirtualPageLoad(ADD_VOUCHER);
  }

  render() {
    const { voucher, addVoucherError } = this.props;
    const formConfig = addVoucherConfig();

    if (this.props.isOpen && !voucher) {
      analyticsTrigger(DATA_STATE_CHANGE, pageNames.ADD_VOUCHER);
    }
    if (this.props.isOpen && voucher) {
      analyticsTrigger(DATA_STATE_CHANGE, pageNames.ADD_VOUCHER_SUCCESS);
    }

    const validate = (values) => {
      const errors = {};
      formConfig.fields.forEach((field) => {
        if (field.required && !values[field.name]) {
          errors[field.name] = field.validationMessageKeys?.required || 'This field is required';
        }
        if (field.minLength && values[field.name]?.length < field.minLength) {
          errors[field.name] =
            field.validationMessageKeys?.minLength ||
            `Minimum ${field.minLength} characters required`;
        }
        if (field.maxLength && values[field.name]?.length > field.maxLength) {
          errors[field.name] =
            field.validationMessageKeys?.maxLength ||
            `Maximum ${field.maxLength} characters allowed`;
        }
      });
      return errors;
    };

    return (
      <Modal
        title="Add Voucher"
        isOpen={this.props.isOpen}
        onClose={() => this.onModalClose()}
        rootId="root"
        footer={false}
      >
        <div className={base.modalContent}>
          {!voucher ? (
            <div className={styles.form}>
              {addVoucherError && (
                <Message
                  type="error"
                  title={addVoucherError.message}
                  body={addVoucherError.body}
                  refreshes={addVoucherError.refreshes}
                  animation="shake"
                  data-testid="add-voucher-error"
                />
              )}
              <Form
                onSubmit={this.onFormSubmit}
                validate={validate}
                render={({ handleSubmit, submitting }) => (
                  <form onSubmit={handleSubmit} data-testid="add-voucher-form">
                    {formConfig.fields.map((field) => {
                      if (field.extra && field.component === 'img') {
                        return <img key={field.name} {...field.props} />;
                      }

                      return (
                        <Field key={field.name} name={field.name}>
                          {({ input, meta }) => {
                            const showError = meta.touched && meta.error;
                            const FieldComponent = field.component;

                            return (
                              <FieldComponent
                                {...input}
                                {...field}
                                id={field.id}
                                type={field.type}
                                placeholder={field.placeholder}
                                autoComplete={field.autoComplete}
                                minLength={field.minLength}
                                maxLength={field.maxLength}
                                error={showError ? meta.error : undefined}
                                onChange={(e) => {
                                  const value = field.normalize
                                    ? field.normalize(e.target.value)
                                    : e.target.value;
                                  input.onChange(value);
                                }}
                              />
                            );
                          }}
                        </Field>
                      );
                    })}
                    <PrimaryButton type="submit" disabled={submitting} className="mt-4">
                      {formConfig.submitButton}
                    </PrimaryButton>
                  </form>
                )}
              />
            </div>
          ) : (
            <div className="text-center">
              <Icon
                name="tick"
                className={`${base.tick} mb-4`}
                onClick={() => this.onModalClose()}
              />
              <h3 className="mb-5">
                Your voucher has been successfully added.
                <br />
                Your new balance is{' '}
                <strong data-testid="voucher-balance">{renderPrice(voucher.newBalance)}</strong>
              </h3>
              <PrimaryButton
                className="mb-0"
                onClick={() => this.onModalClose()}
                data-testid="done-btn"
              >
                Done
              </PrimaryButton>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default connect(
  (state) => ({
    voucher: state.voucher && state.voucher.voucher,
    addVoucherError: state.voucher && state.voucher.addVoucherError,
  }),
  {
    submitVoucher: submitVoucherAction,
  },
)(AddVoucherModal);
